import axios from "axios";
import store from "./configStore";

export const AxiosService = ({ method, base_url, endPoint, payload, ContentType, isAuth }) => {
    const state = store.getState();
    let accessToken = state.utilReducers?.accessToken
    // let accessToken = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIyNDciLCJpYXQiOjE3NTkxMzI0NTQsImV4cCI6MTc1OTk5NjQ1NH0.Y7WE2mQx_qhTjojcWaBq4YBXQRDAH3R1LHT-uT3oUyCBmQB44Uw0AeWzsHFJPdt_-JGI0UDTK1zGhDHtse3cVg'

    console.log('====================================');
    console.log("calling AxiosService: ",
        {
            "method": method,
            "url": base_url + endPoint,
            "body": payload,
            "ContentType": ContentType ? ContentType : 'application/json',
            "isAuth": isAuth,
            "token": accessToken,
        }
    );
    console.log('====================================');
    if (method === 'get') {
        return axios({
            method: method,
            url: base_url + endPoint,
            headers: isAuth ?
                {
                    'Content-Type': ContentType ? ContentType : 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                }
                :
                {
                    'Content-Type': ContentType ? ContentType : 'application/json',
                },
        });
    } else if (method === 'post' || method === 'put') {
        return axios({
            method: method,
            url: base_url + endPoint,
            data: payload,
            headers: isAuth ?
                {
                    'Content-Type': ContentType ? ContentType : 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                }
                :
                {
                    'Content-Type': ContentType ? ContentType : 'application/json',
                },
        });
    } else {
        return axios({
            method: method,
            url: base_url + endPoint,
            data: payload,
            headers: isAuth ?
                {
                    'Content-Type': ContentType ? ContentType : 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                }
                :
                {
                    'Content-Type': ContentType ? ContentType : 'application/json',
                },
        });
    }
};